import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { Grid2, Input, TextArea } from "./AdminSimulators";

export default function AdminSettings() {
  const [s, setS] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/settings");
      setS(data);
    })();
  }, []);

  const save = async () => {
    try {
      const { data } = await api.put("/admin/settings", s);
      setS(data);
      toast.success("Configurações salvas");
    } catch (e) { toast.error("Erro ao salvar"); }
  };

  if (!s) return <div className="text-neutral-500">Carregando...</div>;
  const upd = (k, v) => setS({ ...s, [k]: v });

  return (
    <div data-testid="admin-settings">
      <div className="mb-8 flex justify-between items-end">
        <div>
          <div className="overline text-neutral-500 mb-2">Site</div>
          <h1 className="font-display font-black text-3xl">Configurações</h1>
        </div>
        <button onClick={save} className="inline-flex items-center gap-2 rounded-full bg-[#E31B23] px-6 py-2.5 text-sm font-semibold glow-red" data-testid="settings-save">
          <Save className="w-4 h-4" /> Salvar
        </button>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <Card title="Hero">
          <Input label="Título linha 1" v={s.hero_title_line1} on={(v) => upd("hero_title_line1", v)} />
          <Input label="Título linha 2" v={s.hero_title_line2} on={(v) => upd("hero_title_line2", v)} />
          <TextArea label="Subtítulo" v={s.hero_subtitle} on={(v) => upd("hero_subtitle", v)} />
          <Input label="Imagem de fundo (URL)" v={s.hero_image_url} on={(v) => upd("hero_image_url", v)} />
          <Input label="Logo (URL)" v={s.logo_url} on={(v) => upd("logo_url", v)} />
        </Card>

        <Card title="Sobre">
          <TextArea label="Texto institucional" v={s.about_text} on={(v) => upd("about_text", v)} rows={6} />
        </Card>

        <Card title="Contato">
          <Grid2>
            <Input label="Telefone" v={s.phone} on={(v) => upd("phone", v)} />
            <Input label="WhatsApp (apenas números)" v={s.whatsapp} on={(v) => upd("whatsapp", v)} />
            <Input label="E-mail" v={s.email} on={(v) => upd("email", v)} />
            <Input label="Cidade" v={s.city} on={(v) => upd("city", v)} />
            <Input label="Instagram" v={s.instagram} on={(v) => upd("instagram", v)} />
            <Input label="Facebook" v={s.facebook} on={(v) => upd("facebook", v)} />
          </Grid2>
          <Input label="Google Maps embed URL" v={s.map_embed_url} on={(v) => upd("map_embed_url", v)} />
        </Card>

        <Card title="Estatísticas">
          <Grid2>
            <Input label="Eventos (+)" type="number" v={s.stats_events} on={(v) => upd("stats_events", Number(v))} />
            <Input label="Simuladores (+)" type="number" v={s.stats_simulators} on={(v) => upd("stats_simulators", Number(v))} />
            <Input label="Pessoas (+)" type="number" v={s.stats_people} on={(v) => upd("stats_people", Number(v))} />
            <Input label="Diversão (%)" type="number" v={s.stats_fun} on={(v) => upd("stats_fun", Number(v))} />
          </Grid2>
        </Card>
      </div>
    </div>
  );
}

const Card = ({ title, children }) => (
  <div className="rounded-xl border border-white/5 bg-[#0a0a0a] p-6 space-y-4">
    <div className="overline text-[#E31B23]">{title}</div>
    {children}
  </div>
);
